import { ElementRef, inject, viewChild } from '@angular/core';
import { ALERTS_FEATURE, DASHBOARD_FEATURE, NOTES_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { ACTION_DROPDOWN_CONFIG } from 'SecuritiesApp/ts/constants/security-header-control.constants';
import { VALUE_ADD_TO_WATCHLIST, VALUE_NOTES } from 'SecuritiesApp/ts/constants/security-header-dropdown.constants';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { SecurityHeaderDropdownModule } from 'SecuritiesApp/ts/features/security-header-dropdown/security-header-dropdown.module';
import { SymbolSwitcherModule } from 'SecuritiesApp/ts/features/symbol-switcher/symbol-switcher.module';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i2 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../security-header-dropdown/security-header-dropdown.component";
import * as i4 from "../symbol-switcher/symbol-switcher.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function PublicSecurityHeaderComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-symbol-switcher", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("securityType", ctx_r0.securityType)("securityUrlIdentifier", ctx_r0.securityUrlIdentifier);
} }
function PublicSecurityHeaderComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function PublicSecurityHeaderComponent_Conditional_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.openFeatureNeeded(ctx_r0.ALERTS_FEATURE)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-alert");
} }
function PublicSecurityHeaderComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-share");
} }
function PublicSecurityHeaderComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function PublicSecurityHeaderComponent_Conditional_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.openFeatureNeeded(ctx_r0.NOTES_FEATURE)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-notes");
} }
function PublicSecurityHeaderComponent_Conditional_6_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Watchlist");
    i0.ɵɵelementEnd();
} }
function PublicSecurityHeaderComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function PublicSecurityHeaderComponent_Conditional_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.openFeatureNeeded(ctx_r0.DASHBOARD_FEATURE)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 10);
    i0.ɵɵconditionalCreate(2, PublicSecurityHeaderComponent_Conditional_6_Conditional_2_Template, 2, 0, "span");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-add");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showAddToWatchlistLabel ? 2 : -1);
} }
function PublicSecurityHeaderComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 10);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Reports");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-overview");
} }
function PublicSecurityHeaderComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-security-header-dropdown", 13);
    i0.ɵɵlistener("handler", function PublicSecurityHeaderComponent_Conditional_8_Template_ycn_security_header_dropdown_handler_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.actionDropdownHandler($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("buttonClass", "btn btn-secondary dropdown-toggle user-select-none")("dropdownConfig", ctx_r0.actionDropdownConfig)("dropdownClass", "dropdown-menu-with-icons dropdown-menu-right");
} }
// Indicators have no peers to switch between; mirrors SecurityHeaderControlComponent
const INDICATOR_SECURITY_TYPE = 'indicator';
/**
 * Public Security Header
 *
 * The anonymous stand-in for SecurityHeaderControlComponent: same host element, attributes and controls, so
 * the page looks the same, but without the modules behind those controls. A logged-out visitor has no
 * features, so every control resolves the way the full header resolves it for them: the feature-needed
 * (trial signup) modal, or nothing for the controls the full header disables.
 */
export class PublicSecurityHeaderComponent {
    constructor() {
        this.ALERTS_FEATURE = ALERTS_FEATURE;
        this.DASHBOARD_FEATURE = DASHBOARD_FEATURE;
        this.NOTES_FEATURE = NOTES_FEATURE;
        // Add to Watchlist needs a feature the visitor lacks, so it is disabled as in the full header
        this.actionDropdownConfig = {
            ...ACTION_DROPDOWN_CONFIG,
            list: ACTION_DROPDOWN_CONFIG.list.map((option) => option.value === VALUE_ADD_TO_WATCHLIST ? { ...option, disabled: true } : option),
        };
        this.host = inject(ElementRef).nativeElement;
        this.featureNeeded = viewChild.required(FeatureNeededComponent);
        this.securityUrlIdentifier = '';
        this.showSymbolSwitcher = false;
        this.showAlertsButton = false;
        this.showShareButton = false;
        this.showNotesButton = false;
        this.showAddToWatchlistButton = false;
        this.showAddToWatchlistLabel = false;
        this.showCustomPDFReports = false;
        this.showActionsDropdown = false;
    }
    // Read in ngOnInit rather than the constructor so bound attributes are present too, not only static ones
    ngOnInit() {
        const security = JSON.parse(this.host.getAttribute('security') ?? '{}');
        const flag = (name) => this.host.getAttribute(name) === 'true';
        this.securityType = security.security_type;
        this.securityUrlIdentifier = this.host.getAttribute('securityUrlIdentifier') ?? '';
        this.showSymbolSwitcher = this.securityType !== INDICATOR_SECURITY_TYPE;
        this.showAlertsButton = flag('showAlertsButton');
        this.showShareButton = flag('showShareButton');
        this.showNotesButton = flag('showNotesButton');
        this.showAddToWatchlistButton = flag('showAddToWatchlistButton');
        this.showAddToWatchlistLabel = flag('showAddToWatchlistLabel');
        this.showCustomPDFReports = flag('showCustomPDFReports');
        this.showActionsDropdown = flag('showActionsDropdown');
    }
    openFeatureNeeded(feature) {
        this.featureNeeded().openModal(feature);
    }
    // Only Notes is enabled in the dropdown for a visitor without features
    actionDropdownHandler(item) {
        if (item.value === VALUE_NOTES)
            this.openFeatureNeeded(NOTES_FEATURE);
    }
}
PublicSecurityHeaderComponent.ɵfac = function PublicSecurityHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PublicSecurityHeaderComponent)(); };
PublicSecurityHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PublicSecurityHeaderComponent, selectors: [["ycn-security-header-control"]], viewQuery: function PublicSecurityHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.featureNeeded, FeatureNeededComponent, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, decls: 10, vars: 7, consts: [[1, "page-header-options", "col-auto"], [3, "securityType", "securityUrlIdentifier"], [1, "form-inline"], ["ycnTooltip", "", "tooltipTitle", "Alerts", 1, "btn", "btn-secondary"], ["ycnTooltip", "", "tooltipTitle", "Share", 1, "btn", "btn-secondary", "disabled"], [1, "btn", "btn-secondary"], ["ycnTooltip", "", "tooltipTitle", "Add to Watchlist", 1, "btn", "btn-secondary", "disabled"], [1, "btn", "btn-secondary", "disabled"], [3, "buttonClass", "dropdownConfig", "dropdownClass"], ["ycnTooltip", "", "tooltipTitle", "Alerts", 1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "btn", "btn-secondary", 3, "click"], ["ycnTooltip", "", "tooltipTitle", "Add to Watchlist", 1, "btn", "btn-secondary", "disabled", 3, "click"], [3, "handler", "buttonClass", "dropdownConfig", "dropdownClass"]], template: function PublicSecurityHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, PublicSecurityHeaderComponent_Conditional_1_Template, 1, 2, "ycn-symbol-switcher", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵconditionalCreate(3, PublicSecurityHeaderComponent_Conditional_3_Template, 2, 1, "div", 3);
        i0.ɵɵconditionalCreate(4, PublicSecurityHeaderComponent_Conditional_4_Template, 2, 1, "div", 4);
        i0.ɵɵconditionalCreate(5, PublicSecurityHeaderComponent_Conditional_5_Template, 2, 1, "div", 5);
        i0.ɵɵconditionalCreate(6, PublicSecurityHeaderComponent_Conditional_6_Template, 3, 2, "div", 6);
        i0.ɵɵconditionalCreate(7, PublicSecurityHeaderComponent_Conditional_7_Template, 4, 1, "div", 7);
        i0.ɵɵconditionalCreate(8, PublicSecurityHeaderComponent_Conditional_8_Template, 1, 3, "ycn-security-header-dropdown", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(9, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showSymbolSwitcher ? 1 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showAlertsButton ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showShareButton ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showNotesButton ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showAddToWatchlistButton ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showCustomPDFReports ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showActionsDropdown ? 8 : -1);
    } }, dependencies: [FeatureNeededModule, i1.FeatureNeededComponent, IconModule, i2.IconDirective, SecurityHeaderDropdownModule, i3.SecurityHeaderDropdownComponent, SymbolSwitcherModule, i4.SymbolSwitcherComponent, TooltipModule, i5.TooltipDirective], encapsulation: 2, changeDetection: 0 });
